import { render, staticRenderFns } from "./SimpleModal.vue?vue&type=template&id=4e1e7a28&scoped=true&"
import script from "./SimpleModal.vue?vue&type=script&lang=ts&"
export * from "./SimpleModal.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleModal.vue?vue&type=style&index=0&id=4e1e7a28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1e7a28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
